import { FC } from "react";

import { Calendar, Globe, Wallet, Settings, User } from "shared/assets/icons";
import { SideMenu } from "shared/components";
import { ISideMenuItem } from "shared/components/SideMenu/types";
import { copy } from "shared/assets";

import { BAND_PATHS } from "Bands/router";
import { useBandContext } from "Bands/contexts";
import { useMemo } from "react";
import { useBandRoute } from "Bands/utils";

const {
  bandSettings: { sidemenu, bandSettingsIds },
} = copy;

export const BandSettingsSideMenu: FC = () => {
  const { bandId, band } = useBandContext();
  const { getPath } = useBandRoute();

  const items: ISideMenuItem[] = useMemo(
    () =>
      bandId
        ? [
            {
              id: bandSettingsIds.band,
              title: sidemenu.band,
              path: getPath(BAND_PATHS.BAND_SETTINGS, {
                hash: bandSettingsIds.band,
              }),
              icon: Settings,
            },
            {
              id: bandSettingsIds.subscription,
              title: sidemenu.subscription,
              path: getPath(BAND_PATHS.BAND_SETTINGS, {
                hash: bandSettingsIds.subscription,
              }),
              icon: Wallet,
            },
            {
              id: bandSettingsIds.regional,
              title: sidemenu.regional,
              path: getPath(BAND_PATHS.BAND_SETTINGS, {
                hash: bandSettingsIds.regional,
              }),
              icon: Globe,
            },
            {
              id: bandSettingsIds.event,
              title: sidemenu.event,
              path: getPath(BAND_PATHS.BAND_SETTINGS, {
                hash: bandSettingsIds.event,
              }),
              icon: Calendar,
            },
            {
              id: bandSettingsIds.member,
              title: sidemenu.member,
              path: getPath(BAND_PATHS.BAND_SETTINGS, {
                hash: bandSettingsIds.member,
              }),
              icon: User,
            },
          ]
        : [],
    [bandId, getPath]
  );

  if (!bandId) return null;

  return (
    <SideMenu
      title={band?.title || ""}
      titleUrl={getPath(BAND_PATHS.BAND_SETTINGS)}
      items={items}
    />
  );
};
